//import firebase from 'firebase'
import React from 'react'
import {connect} from "react-redux"
import {withRouter} from 'react-router'
import AreasPageContent from './AreasPageContent'
import { setTitle, fetchTherapyAreas, fetchTherapyCategories } from "../../actions"

@connect((store) => {
	return {
    User: store.User.User,
    therapy_areas: store.therapy_areas,
    therapy_categories: store.therapy_categories,
    videos: store.videos,
	practice_types: store.practice_types,
	practices: store.practices
  };
})
class AreasPage extends React.Component {
	constructor(props){
		super(props)
		this.search = this.search.bind(this)
		this.areas = this.areas.bind(this);
		this.videoClick = this.videoClick.bind(this)
		this.toggleCompact = this.toggleCompact.bind(this)
		this.goToArea = this.goToArea.bind(this)
		this.isOnlyParent = this.isOnlyParent.bind(this);
		this.userTypeForProfessionFilter = this.userTypeForProfessionFilter.bind(this);
		this.setUp = this.setUp.bind(this);
		this.state = {
			'search': '',
			'compact': false,
			'filteredPracticeTypes': [],
			'professionSelection': ''
		}
	}

	componentDidUpdate(nextProps, nextState) {
		const { User, practice_types } = this.props;

		if (User.token && User.name != nextProps.User.name) {
			this.setUp();
		}

		if (practice_types !== nextProps.practice_types) {
			// console.log('Setup Profession Filter');
			this.userTypeForProfessionFilter();
		}


		if (this.state.filteredPracticeTypes != nextState.filteredPracticeTypes) {
			// console.log('Setup Profession selection');
			this.getProfessionSelection();
		}
	}
	
	componentWillMount(){
		const { User } = this.props;
		if (User.token && User.name != '') {
			this.setUp();
		}
	}

	setUp() {
		const { User, dispatch, practice_types } = this.props;
		dispatch(setTitle('Resources'));
		dispatch(fetchTherapyAreas());
		dispatch(fetchTherapyCategories());
		this.userTypeForProfessionFilter();
		this.getProfessionSelection();
	}

	search(e){
		this.setState({
			'search': e.target.value
		})
	}

	goToArea(id){
		const { history } = this.props;
		history.push(`/page/therapy_areas/${id}`)
	}

	videoClick(video){
		const { history } = this.props;
		history.push(`/page/videos/${video._id}`)
	}

	toggleCompact(){
		this.setState({
			'compact': !this.state.compact
		})
	}

	areas(){
		const { therapy_areas } = this.props;
		const { search } = this.state;
		const searchExp = new RegExp(search, 'i')
		return Object.values(therapy_areas).filter(a => a.name.match(searchExp))
	}

	isOnlyParent(){
		const {User} = this.props;

		return !(User.owner || User.therapist)
	}


	userTypeForProfessionFilter(){
		const {User, practice_types} = this.props;

		// IF USER IS ADMIN
		if (User.admin){
			this.setState({
				'filteredPracticeTypes': practice_types
			})
			return
		}

		let pracs = [...User.ownPractices, ...User.therapistPractices, ...User.practices];
		let filterPracticeTypes = [];
		// console.log("pracs: ", pracs);
		
		// Check and remove duplicates pracs
		pracs = pracs.filter((prac, index, self) => {
			if (prac !== undefined){
				return index === self.findIndex((t) => {
					if (t !== undefined) {
						return t.id === prac.id
					}
				})
			}
		});
		// console.log(pracs);

		pracs.forEach(prac => {
			if (prac !== undefined) {
				let pracFiltered = practice_types.find((type) => {
					if (type !== undefined) {
						return prac.practice_type === type.id;
					}
				});
				if (pracFiltered !== undefined) {
					filterPracticeTypes.push(pracFiltered);	
				}
			}
		});

		// Check and remove duplicates
		filterPracticeTypes = filterPracticeTypes.filter((prac, index, self) => {
			if (prac !== undefined) {
				return index === self.findIndex((t) => {
					if (t !== undefined) {
						return t._id === prac._id
					}
				});
			}
		});
		// console.log('Filter Practice Types', filterPracticeTypes);
		this.setState({
			filteredPracticeTypes: filterPracticeTypes
		});
	}

	getProfessionSelection() {
		const { User } = this.props;
		// console.log(User);
		// console.log(filteredPracticeTypes);
		let professionSelection = "";
		if (User.ownPractices && User.ownPractices.length > 0) {
			professionSelection = User.ownPractices[0].practice_type
		} else if (User.therapistPractices && User.therapistPractices.length > 0) {
			professionSelection = User.therapistPractices[0].practice_type
		} else if (User.practices && User.practices.length > 0) {
			professionSelection = User.practices[0].practice_type
		}

		this.setState({
			professionSelection: professionSelection
		});
	}

	render() {
		const { therapy_categories, videos, params } = this.props;
		const { compact, filteredPracticeTypes, professionSelection } = this.state;

		return <AreasPageContent
			goToArea={this.goToArea}
			category={params.catId}
			videos={videos}
			userType = {this.userTypeForProfessionFilter}
			isOnlyParent ={this.isOnlyParent}
			videoClick={this.videoClick}
			handleSearch={this.search}
			compact={compact}
			toggleCompact={this.toggleCompact}
			therapy_areas={this.areas()}
			therapy_categories={Object.values(therapy_categories)}
			practice_types={filteredPracticeTypes} 
			professionSelection={professionSelection}	
			/>
	}
}

export default withRouter(AreasPage);



// WEBPACK FOOTER //
// ./src/components/home/AreasPage.jsx